// extracted by mini-css-extract-plugin
export default {"tabContainer":"TabNav_tabContainer__x2Tak","tabs":"TabNav_tabs__uukLO","active":"TabNav_active__XwqzT"};